import TableFilterTags from './tableFilterTags';

export default TableFilterTags;
